<div class='ra-mask ra-mask-centermodal ra-mask-bluebg ra-hide' data-id='idModalBrowserChangeSafari'>
    <div class="ra-modal-position ra-modal-alert ra-modal-personalask">
        <button class="ra-modal-close" data-close='idModalBrowserChangeSafari'></button>
        <div class="ra-modal-container">
            <div class="ra-modal-body ra-modal-alert">
                <p class='txt-ra-modal txt-align-center'>建議您使用Safari瀏覽此網頁，以獲得最佳瀏覽體驗</p>
            </div>
            <div class="ra-modal-footer">
                <div class="ra-modal-btn-wrapper-left-right">
                    <button class="ra-btn ra-half-btn ra-btn-height-small ra-btn-primary " data-close='idModalBrowserChangeSafari'>
                        <span class='txt-btn-confirm'>我知道了</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class='ra-mask ra-mask-centermodal ra-mask-bluebg ra-hide' data-id='idModalBrowserChangeChrome'>
    <div class="ra-modal-position ra-modal-alert ra-modal-personalask">
        <button class="ra-modal-close" data-close='idModalBrowserChangeChrome'></button>
        <div class="ra-modal-container">
            <div class="ra-modal-body ra-modal-alert">
                <p class='txt-ra-modal txt-align-center'>建議您使用Chrome瀏覽此網頁，以獲得最佳瀏覽體驗</p>
            </div>
            <div class="ra-modal-footer">
                <div class="ra-modal-btn-wrapper-left-right">
                    <button class="ra-btn ra-half-btn ra-btn-height-small ra-btn-primary " data-close='idModalBrowserChangeChrome'>
                        <span class='txt-btn-confirm'>我知道了</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class='ra-mask-transparent ra-mask-privacy ' #idModalPrivacy data-id='idModalPrivacy'>
    <div class="ra-modal-position">
        <button class="ra-modal-close" (click)="idModalPrivacy.classList.add('ra-hide')" data-close='idModalPrivacy'></button>
        <div class="ra-modal-container ra-modal-blueborder">
            <div class="ra-modal-body">
                <p class='txt-ra-modal'><b>為提供您最佳個人化且即時的服務，本網站透過使用Cookies記錄與存取您的瀏覽使用訊息。</b>當您繼續瀏覽(使用)本網站，即表示您同意Cookies技術支援。</p>
                <div class="ra-privacy-row">
                    <div class="ra-privacy-col1">
                        <p class='txt-ra-modal txt-align-left'>了解更多資訊請參閱</p>
                    </div>
                    <div class="ra-privacy-col2">
                        <a class='txt-ra-modal-link txt-link-witharrow' href='https://www.allianz.com.tw/zh_TW/statement.html' target='_blank'>隱私權保護聲明</a>
                        <!-- <a class='txt-ra-modal-link txt-link-witharrow' href='javascript:;' data-open="idModalCookies">Cookies政策</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class='ra-mask ra-mask-centermodal ra-mask-bluebg ra-hide' #idModalPersonalInfoQues data-id='idModalPersonalInfoQues'>
    <div class="ra-modal-position ra-modal-alert ra-modal-personalinfo">
        <!-- <button class="ra-modal-close" data-close='idModalPersonalInfoQues'></button> -->
        <div class="ra-modal-container ra-modal-personalinfo">
            <div class="ra-modal-body ra-modal-alert ra-modal-personalinfo">
                <p class='txt-ra-modal'>請詳閱個資聲明，並點擊確認您已瞭解相關權益規範</p>
                <div class="msg-bbl-note-scroll scrollbar-inner" #idPersonalInfoScroll id='idPersonalInfoScroll'>
                    <div class="ra-modal-api-tag-box">
                        <h1>個人資料蒐集、處理、利用告知事項</h1>
                        <p>安聯人壽保險股份有限公司(下稱安聯人壽)依據個人資料保護法 (下稱個資法) 第八條第一項規定，向您告知下列事項，請您詳閱： </p>
                        <p></p>
                        <h2>一、蒐集之目的：</h2>
                        <p>安聯人壽保險商品或服務之介紹、保險商品行銷服務以及資料統計、研究、分析。  </p>
                        <p></p>
                        <h2>二、蒐集之個人資料類別：</h2>
                        <p>安聯人壽所蒐集 您的個人資料，於所涉業務執行即蒐集目的之必要範圍內，除相關法令明文限制外，包括您的姓名、行動電話、電子郵件地址(電子信箱)、性別、年齡、職業、薪資收入、己累積存款、每月儲蓄/投資、有無將勞工保險給付及退休金納入退休規劃、希望退休年齡等依法得蒐集之個人資料。</p>
                        <h2>三、利用之期間、地區、對象及方式：</h2>
                        <p>(一) 期間：因執行業務所必須及依法令規定應為保存之期間。</p>
                        <p>(二) 對象：安聯人壽。</p>
                        <p>(三) 地區：中華民國境內。</p>
                        <p>(四) 方式：合於法令規定之利用方式。</p>
                        <p></p>
                        <h2>四、當事人權利行使：</h2>
                        <p>您可依個人資料保護法第三條之規定行使相關權利，如查詢或請求閱覽、請求製給複製本(依法安聯人壽得向您酌收必要成本費用)、請求補充或更正、請求停止蒐集、處理或利用、請求刪除個人資料，惟依法安聯人壽因執行業務所必須者，得不依本人請求或請求方式為之。</p>
                        <p></p>
                        <h2>五、您拒不提供個人資料所致權益之影響：</h2>
                        <p>您得自由選擇是否提供相關個人資料，惟若拒絕提供相關個人資料，安聯人壽將無法提供相關之服務。</p>
                    </div>
                </div>
                <div class="msg-bbl-btn-wrapper">
                    <!-- data-open ="idModalPersonalInfoAgreeNote" data-close ="idModalPersonalInfoQues" -->
                    <button class="ra-btn ra-full-btn ra-btn-primary jsBtnDisabled"
                             (click)="agree()" #isPrivacyAgreeBtn
                             data-href='chat.html' id="isPrivacyAgreeBtn">
                        <span class='txt-btn-confirm'>同意，我已詳細閱讀安聯人壽個資聲明</span>
                    </button>
                    <p class='txt-ra-modal txt-align-center ra-hide' #idModalPersonalInfoAgreeNote
                       style='font-size:12px;' data-id='idModalPersonalInfoAgreeNote'>
                        您需要捲動到個資聲明最底下，詳閱後才能點擊確認！<br>
                        <a href='javascript:;' (click)="idModalPersonalInfoAgreeNote.classList.add('ra-hide')"
                           data-close='idModalPersonalInfoAgreeNote' class='txt-highlight' style="font-size:inherit;">我知道了</a>
                    </p>
                    <button class="ra-btn ra-full-btn ra-btn-secondary "
                            (click)="idModalPersonalInfoQues.classList.add('ra-hide');idModalPersonalInfoAsk.classList.remove('ra-hide')"
                            data-open='idModalPersonalInfoAsk' data-close ="idModalPersonalInfoQues">
                        <span class='txt-btn-secondary'>不同意</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class='ra-mask ra-mask-centermodal ra-mask-bluebg ra-hide' #idModalPersonalInfoAsk data-id='idModalPersonalInfoAsk'>
    <div class="ra-modal-position ra-modal-alert ra-modal-personalask">
        <button class="ra-modal-close"
                (click)="idModalPersonalInfoAsk.classList.add('ra-hide'); idModalPersonalInfoQues.classList.remove('ra-hide')"
                data-close='idModalPersonalInfoAsk' data-open="idModalPersonalInfoQues"></button>
        <div class="ra-modal-container">
            <div class="ra-modal-body ra-modal-alert">
                <p class='txt-ra-modal'>如您不同意安聯人壽個資聲明內容，系統將退出此問卷，作答資料不會儲存與送出。</p>
            </div>
            <div class="ra-modal-footer">
                <div class="ra-modal-btn-wrapper-left-right">
                    <button class="ra-btn ra-half-btn ra-btn-height-small ra-btn-primary "
                            (click)="disagree()"
                            id='isPrivacyDeleteBtn' data-href="thx_delete.html">
                        <span class='txt-btn-confirm'>確定刪除</span>
                    </button>
                    <button class="ra-btn ra-half-btn ra-btn-height-small ra-btn-secondary "
                            (click)="idModalPersonalInfoAsk.classList.add('ra-hide'); idModalPersonalInfoQues.classList.remove('ra-hide')"
                            data-close='idModalPersonalInfoAsk' data-open="idModalPersonalInfoQues">
                        <span class='txt-btn-secondary'>取消返回</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="ra-mask ra-mask-bluebg ra-hide" data-id="idModalVideo">
    <div class="ra-full-video-wrapper" >
        <button class="ra-video-close" data-close='idModalVideo'>
            <span class="ndbx-icon ra-icon-32 ra-icon--close"></span>
        </button>
        <div class="ra-video-container">
            <iframe width="560" height="315" id="idYTVideo"
                    src="https://www.youtube.com/embed/9K1JxMrfk78" title="安聯退休需求解決方案"
                    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            <!-- <iframe width="560" height="315" id="idYTVideo"
            src="https://www.youtube.com/embed/vsFXXTYTKQQ" title="安聯退休需求解決方案"
            frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe> -->

        </div>
    </div>
</div>
<!-- <div class='ra-mask ra-mask-cookies ra-hide' data-id='idModalCookies'>
  <div class="ra-modal-position">
    <button class="ra-modal-close" data-close='idModalCookies'></button>
    <div class="ra-modal-container ra-modal-blueborder">
      <div class="ra-modal-api-tag-box">
        <h1>Cookies之運用</h1>
        <p>一、基於網站內部管理之需要及提供最佳個人化服務，本公司網站將在您的瀏覽器中寫入Cookies。Cookies會識別使用者的電腦，但是不會連結至使用者的個人資料，無法識別使用者的身分。</p>
        <p>另外，本網站將使用Cookies進行網路行為調查之總量數據分析，做為本網站改善服務的參考，由 Cookies 蒐集而來的資訊，將依照「隱私權聲明」以不具名的方式彙整利用。</p>
        <p>二、若您不願接受 Cookies 的寫入，您可將使用中之瀏覽器設定為拒絕 Cookies 的寫入，但也因此會使網站某些功能無法正常執行。</p>
      </div>
      <div class="ra-modal-footer">
        <a href="javascript:;" class='txt-ra-modal-link' data-close="idModalCookies">關閉</a>
      </div>
    </div>
  </div>
</div> -->
<header class='ra-header'>
    <a href="javascript:;" class="ra-logo" title='回首頁'></a>
    <div class='ra-social'>
        <a href="javascript:;" appSocialShare="fb" class='ra-social-fb' title='問卷分享至Facebook'></a>
        <a href="javascript:;" appSocialShare="line" class='ra-social-line' title='問卷分享至LINE'></a>
    </div>

</header>
<div class="ra-idx-wrapper">
    <div class="ra-idx-box title-wrapper" data-open="idModalPersonalInfoQues">
        <div class="ra-idx-title" title='安聯人壽智慧退休小幫手'><img class='fluid' src="assets/img/idx_title.svg" alt=""></div>
        <div class="ra-idx-pinktitle txt-idx-pinktitle txt-align-center">嗨！您好，只需簡單幾步驟，<span class='ra-idx-pinktitle-br'><br></span>找出專屬於您的保險退休計畫！</div>
        <div class="ra-btn ra-idx-btn ra-btn-txt-arrow-tail" (click)="showAgree()">
            <span class='txt-idx-btn-txt'>精彩規劃，立即開始</span>
        </div>
    </div>
    <div class="ra-idx-box graph-wrapper">
        <div class="ra-graph-wrapper-relative">
            <div class="ra-city-robot">
                <img class="fluid" src='assets/img/idx_robot.png' alt="robo robot">
            </div>
            <div class="ra-city-box">
                <div class="ra-city-box-relative">
                    <div class="ra-city-video ">
                        <div class="ra-video-container jsVideoPreview" data-open="idModalVideo">
                            <a href='javascript:;' class='ra-video-playbtn' alt='播放影片按鈕'></a>
                            <!-- <img class='fluid imgVideoPrev' style='z-index:1;' src="http://img.youtube.com/vi/9K1JxMrfk78/0.jpg" alt=""> -->
                            <img class='fluid imgVideoPrev' style='z-index:1;' src="dataimg/9K1JxMrfk78.jpg" alt="">
                        </div>
                    </div>
                    <div class="ra-city-chart animated infinite floating"><img class="fluid" alt="chart and graph" src='assets/img/idx_city_chart.png'></div>
                    <div class="ra-city "><img class="fluid" alt="robo city" src='assets/img/idx_city.png'></div>
                </div>
            </div>
        </div>

    </div>
</div>
<footer class='ra-footer'>
    <div class="ra-ft-in">
        <div class="ra-ft-copyright txt-ft-cp">©Allianz 2021. All Rights Reserved.</div>
        <div class="ra-ft-link">
            <a href="https://www.allianz.com.tw/zh_TW/statement.html" class='txt-ft-a ra-ft-announce' title='網站聲明' target="_blank">網站聲明</a>
            <!-- <a href="javascript:;" class='txt-ft-a ra-ft-cookies' title='Cookies政策' data-open="idModalCookies">Cookies政策</a> -->
            <a href="https://www.allianz.com.tw/zh_TW/about-us/contact-us/contact-us.html" class='txt-ft-a ra-ft-contact' title='聯絡我們' target="_blank">聯絡我們</a>
        </div>
    </div>
</footer>
